export class ApplicationOverride {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "string",
            "format": ""
        },
        {
            "name": "criticality",
            "baseName": "criticality",
            "type": "number",
            "format": ""
        },
        {
            "name": "isInstalled",
            "baseName": "isInstalled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ApplicationOverride.attributeTypeMap;
    }
    constructor() {
    }
}
